// extracted by mini-css-extract-plugin
export var caption = "Typography-module--caption--638f1";
export var code = "Typography-module--code--3b443";
export var orderedList = "Typography-module--orderedList--b3107";
export var paragraph = "Typography-module--paragraph--10028";
export var preformattedText = "Typography-module--preformattedText--0c815";
export var primaryHeading = "Typography-module--primaryHeading--0e769";
export var quaternaryHeading = "Typography-module--quaternaryHeading--83af4";
export var secondaryHeading = "Typography-module--secondaryHeading--6b9eb";
export var tertiaryHeading = "Typography-module--tertiaryHeading--196f1";
export var unorderedList = "Typography-module--unorderedList--4241f";